import { Box, Stack } from '@mui/material';
import React, { ReactNode } from 'react';

type TwoColumnLayoutProps = {
  leftColumn: ReactNode[];
  rightColumn: ReactNode[];
};

export function TwoColumnLayout({
  leftColumn,
  rightColumn,
}: TwoColumnLayoutProps): React.JSX.Element {
  return (
    <>
      <Box flex={1}>
        <Stack spacing={3}>{leftColumn}</Stack>
      </Box>
      <Box flex={1}>
        <Stack spacing={3}>{rightColumn}</Stack>
      </Box>
    </>
  );
}
